import { BadgeCheck, Building2, Clock, FileSearch, EyeOff } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { STATUS } from "@/lib/api";

const ICONS = { verified: BadgeCheck, listing: Building2, pending: Clock, researched: FileSearch, hidden: EyeOff };

export const StatusBadge = ({ status = "listing", className = "" }) => {
  const meta = STATUS[status] || STATUS.listing;
  const Icon = ICONS[status] || Building2;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={0} data-testid={`status-badge-${status}`}
            className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${meta.cls} ${className}`}>
            <Icon className="h-3.5 w-3.5" aria-hidden /> {meta.label}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{meta.hint}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
